import {LOAD_DISPATCHSHEET_DATA, DELETE_A_DISPATCHSHEET, SAVE_A_DISPATCHSHEET, UPDATE_A_DISPATCHSHEET, UPDATE_A_DISPATCHSHEET_PATH, SET_DISPATCHSHEET_STATUS_FILTER,
    SET_DISPATCHSHEET_PONUMBER_FILTER, SET_DISPATCHSHEET_VIN_FILTER,
    SET_DISPATCHSHEET_PLATE_FILTER, SET_DISPATCHSHEET_LOCATION_FILTER,
    SET_DISPATCHSHEET_STARTTIME_FILTER, SET_DISPATCHSHEET_ENDTIME_FILTER,
    SET_DISPATCHSHEET_CLEAR_ALL_FILTER,CLEAR_A_DISPATCH_ERROR_MESSAGE} from './actions';
 


const initialState = {
  dispatchsheetsArray:[],
    deleteDispatchsheetResp:{},
    errorCMsg:{},
    saveDispatchsheetResp:{},
    updateDispatchsheetResp:{},
    dispatchsheetPath:"",
    dispatchStatusFilter:"",
    dispatchPonumberFilter:"",
    dispatchVinFilter:"",
    dispatchPlateFilter:"",
    dispatchLocationFilter:"",
    dispatchStartTimeFilter:null,
    dispatchEndTimeFilter:null,
};




export default function reducer(state = initialState, action) {
  switch (action.type) {
      case CLEAR_A_DISPATCH_ERROR_MESSAGE:
          return Object.assign({}, state, {
              errorCMsg: {}
          });
      case LOAD_DISPATCHSHEET_DATA:
          return Object.assign({}, state, {
              dispatchsheetsArray: action.dispatchsheetsData
          });
      case DELETE_A_DISPATCHSHEET:
          return Object.assign({}, state, {
              deleteDispatchsheetResp: action.deleteDispatchsheetResponse,
              errorCMsg: action.errorMsg
          });
      case SAVE_A_DISPATCHSHEET:
          return Object.assign({}, state, {
              saveDispatchsheetResp: action.saveDispatchsheetResponse,
              errorCMsg: action.errorMsg
          });
      case UPDATE_A_DISPATCHSHEET:
          return Object.assign({}, state, {
              updateDispatchsheetResp: action.updateDispatchsheetResponse,
              errorCMsg: action.errorMsg
          });
      case UPDATE_A_DISPATCHSHEET_PATH:
          return Object.assign({}, state, {
              dispatchsheetPath: action.filePath
              //errorCMsg: action.errorMsg
          });
      case SET_DISPATCHSHEET_STATUS_FILTER:
          return Object.assign({}, state, {
              dispatchStatusFilter: action.dispatchStatusFilter,
          });
      case SET_DISPATCHSHEET_PONUMBER_FILTER:
          return Object.assign({}, state, {
              dispatchPonumberFilter: action.dispatchPonumberFilter,
          });
      case SET_DISPATCHSHEET_VIN_FILTER:
          return Object.assign({}, state, {
              dispatchVinFilter: action.dispatchVinFilter,
          });
      case SET_DISPATCHSHEET_PLATE_FILTER:
          return Object.assign({}, state, {
              dispatchPlateFilter: action.dispatchPlateFilter,
          });
      case SET_DISPATCHSHEET_LOCATION_FILTER:
          return Object.assign({}, state, {
              dispatchLocationFilter: action.dispatchLocationFilter,
          });
      case SET_DISPATCHSHEET_STARTTIME_FILTER:
          return Object.assign({}, state, {
              dispatchStartTimeFilter: action.dispatchStartTimeFilter,
          });
      case SET_DISPATCHSHEET_ENDTIME_FILTER:
          return Object.assign({}, state, {
              dispatchEndTimeFilter: action.dispatchEndTimeFilter,
          });
      case SET_DISPATCHSHEET_CLEAR_ALL_FILTER:
          return Object.assign({}, state, {
              dispatchStatusFilter:"",
              dispatchPonumberFilter:"",
              dispatchVinFilter:"",
              dispatchPlateFilter:"",
              dispatchLocationFilter:"",
              dispatchStartTimeFilter:null,
              dispatchEndTimeFilter:null,
          });
    
    
      default:
      return state;
  }
}
